import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[_c(VLayout,{staticClass:"similarListings"},_vm._l((_vm.similarListings),function(similarListing){return _c(VFlex,{key:similarListing.id,attrs:{"xs4":""}},[_c('mls-listing-card',{attrs:{"listing":similarListing,"onItemClicked":_vm.onItemClicked,"noHover":""}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }